import React from "react";

function CreateTemplateFragment() {
  return <div>CreateTemplateFragment</div>;
}

export default CreateTemplateFragment;
